import React from 'react';
import { cn } from '../../utils/cn';
import type { HelperTextProps } from './helper-text.types';

/**
 * HelperText component for displaying hints, errors, or additional information
 */
const HelperText: React.FC<HelperTextProps> = ({ type = 'info', visible = true, children, className }) => {
    if (!visible) return null;

    return (
        <div
            data-testid="helper-text"
            className={cn(
                'text-xs mt-1',
                {
                    'text-[var(--color-neutral-60)]': type === 'info',
                    'text-[var(--color-error-50)]': type === 'error',
                },
                className
            )}
        >
            {children}
        </div>
    );
};

export default HelperText;
